module.exports = __webpack_public_path__ + "static/img/slide_img.696a2217.png";